// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-KeywordHighlighter-KeywordHighlighter-module__both";
var _2 = "webpack-components-core-KeywordHighlighter-KeywordHighlighter-module__exclusion";
var _3 = "webpack-components-core-KeywordHighlighter-KeywordHighlighter-module__inclusion";
var _4 = "webpack-components-core-KeywordHighlighter-KeywordHighlighter-module__match";
export { _1 as "both", _2 as "exclusion", _3 as "inclusion", _4 as "match" }
